// BANT qualification status -> Badge variant mapping.
// Mirrors lib/ticket-variants.ts. Traffic-light scheme: success = strongest
// qualification signal, destructive = blocker / disqualifying, outline = unknown.

type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'success'
  | 'warning'
  | 'info'
  | 'escalated'

export type BantCriterion = 'budget' | 'authority' | 'need' | 'timeline'

const budgetVariants: Record<string, BadgeVariant> = {
  Confirmed: 'success',
  Estimated: 'info',
  'No budget': 'destructive',
  Unknown: 'outline',
}

const authorityVariants: Record<string, BadgeVariant> = {
  'Decision Maker': 'success',
  Influencer: 'info',
  User: 'warning',
  Unknown: 'outline',
}

const needVariants: Record<string, BadgeVariant> = {
  Critical: 'success',
  Important: 'info',
  'Nice-to-have': 'warning',
  Unknown: 'outline',
}

const timelineVariants: Record<string, BadgeVariant> = {
  '<30 days': 'success',
  '1-3 months': 'info',
  '3-6 months': 'secondary',
  '6-12 months': 'warning',
  '12+ months': 'destructive',
  Unknown: 'outline',
}

const lookup: Record<BantCriterion, Record<string, BadgeVariant>> = {
  budget: budgetVariants,
  authority: authorityVariants,
  need: needVariants,
  timeline: timelineVariants,
}

export function getBantStatusVariant(
  criterion: BantCriterion,
  value?: string | null
): BadgeVariant {
  if (!value) return 'outline'
  return lookup[criterion][value] ?? 'secondary'
}
